var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageFeatures2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 68,
    viewBox: "0 0 54 68",
    width: 54,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.7498 0h-26.99962c-1.78513.00652931-3.49478.720882-4.75389 1.98634-1.2591 1.26546-1.9648345 2.97869-1.9623735 4.76383l-.03391008 53.99933c-.00246107 1.7851.70327258 3.4983 1.96237358 4.7638 1.25911 1.2655 2.96876 1.9798 4.75389 1.9864h40.53393c1.7886-.0052 3.5026-.718 4.7674-1.9828s1.9776-2.9787 1.9827-4.7674v-40.5zm-10.3271 53.9993-11.9477-11.9466 4.7608-4.7588 7.155 7.1551 14.308-14.3101 4.7587 4.7587zm6.9526-30.3752v-18.56121l18.5622 18.56221z",
    fill: "#1f2937",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFeatures2Icon);
export default __webpack_public_path__ + "static/media/imageFeatures2Icon.5838c6cccd772080a288c35be70ced8e.svg";
export { ForwardRef as ReactComponent };